import React from "react"
import { navigate } from "gatsby";

export interface LinkProps {
  to          : string
  className?  : string;
}

// Absolute URLs (e.g. links built with a urlOrigin, like in navWidget) aren't valid
// Gatsby client-side routes, so they must use a full browser navigation instead.
const isAbsoluteUrl = (url: string) => /^[a-z][a-z0-9+.-]*:\/\//i.test(url);

/** Alternative to Gatsby Link tag that has prefetching (this one doesn't) */
export const Link: React.FC<React.PropsWithChildren<LinkProps>> = ({to, children, ...rest})=>{
  const doNavigate: React.MouseEventHandler<HTMLAnchorElement> = (e)=>{
    e.stopPropagation();
    e.preventDefault();

    if (isAbsoluteUrl(to)) {
      window.location.href = to;
    } else {
      navigate(to);
    }
  }
  return (
    <a href={to} {...rest} onClick={doNavigate}>
      {children}
    </a>
  )
}